import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, Button, FormControl, FormHelperText } from '@material-ui/core';
import { clone, getAge, newId, timeFormat2 } from '../../../../../common/utils';
import { ADD, CHILD, CLIENT, EDIT, ERR, globalData, TEXT, VIEW } from '../../../../../common/common';

const Root = styled(Box)({
    width: '100%',
})

class PanelChild extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                "N.": "",
                "DOB": new Date(),
                "SEX": "",
                "RC": "",
                "AddrNPho": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
            },
            stateData: ["CN", "US"],
            panelState: ADD,
            showMsg: false
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const {
            data,
            panelState,
            stateData
        } = this.state;
        const content = () => {
            if (panelState === VIEW) {
                return clientView()
            } else if (panelState === EDIT || panelState === ADD) {
                return clientEdit()
            }
        }
        const clientView = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Child Name</div>
                        <div>{data["N."]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Date of Birth</div>
                        <div>{timeFormat2(data["DOB"])}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Gender</div>
                        <div>{data["SEX"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Phone Number (Optional)</div>
                        <div>{data["AddrNPho"]["phone"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Choose The Country</div>
                        <div>{data["AddrNPho"]["country"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Street</div>
                        <div>{data["AddrNPho"]["street"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child City</div>
                        <div>{data["AddrNPho"]["city"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child State</div>
                        <div>{data["AddrNPho"]["state"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Zip Code</div>
                        <div>{data["AddrNPho"]["zipcode"]}</div>
                    </div>
                </div>
                <div>
                    <Button size="small" color="primary" onClick={this.handleEdit}>Edit</Button>
                </div>
            </div>
        }
        const clientEdit = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Child Name</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["N."]}
                            onChange={e => this.handleChange(e, 'N.')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "N.")}
                            helperText={this.validator(TEXT, "N.")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Date of Birth</div>
                        <TextField
                            type="date"
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["DOB"]}
                            onChange={e => this.handleChange(e, 'DOB')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "DOB")}
                            helperText={this.validator(TEXT, "DOB")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Gender</div>
                        <FormControl >
                            <RadioGroup
                                row
                                value={data["SEX"]}
                                onChange={e => this.handleChange(e, 'SEX')}
                            >
                                <FormControlLabel disabled={this.isDisabled()} value="male" control={<Radio color="primary" />} label="Male" />
                                <FormControlLabel disabled={this.isDisabled()} value="female" control={<Radio color="primary" />} label="Female" />
                            </RadioGroup>
                            <FormHelperText>{this.validator(TEXT, "SEX")}</FormHelperText>
                        </FormControl>
                    </div>
                    {/* <div className="text-wapper">
                                <div className="text-title">Child Rc</div>
                                <RadioGroup
                                    data
                                    value={data["RC"]}
                                    onChange={e => this.handleChange(e, 'RC')}
                                >
                                    <FormControlLabel disabled={this.isDisabled()} value="son" control={<Radio color="primary" />} label="Son" />
                                    <FormControlLabel disabled={this.isDisabled()} value="daughter" control={<Radio color="primary" />} label="Daughter" />
                                </RadioGroup>
                            </div> */}
                    <div className="text-wapper">
                        <div className="text-title">Child Phone Number (Optional)</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["AddrNPho"]["phone"]}
                            onChange={e => this.handleChange(e, 'phone')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Choose The Country</div>
                        <TextField
                            disabled={this.isDisabled()}
                            select
                            className="text-field"
                            value={data["AddrNPho"]["country"]}
                            onChange={e => this.handleChange(e, 'country')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "AddrNPho", "country")}
                            helperText={this.validator(TEXT, "AddrNPho", "country")}
                        >
                            {stateData.map((data, index) => (
                                <MenuItem key={index} value={data}>
                                    {data}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    {unitView("AddrNPho")}
                    <div className="text-wapper">
                        <div className="text-title">Child Street</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["AddrNPho"]["street"]}
                            onChange={e => this.handleChange(e, 'street')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "AddrNPho", "street")}
                            helperText={this.validator(TEXT, "AddrNPho", "street")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child City</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["AddrNPho"]["city"]}
                            onChange={e => this.handleChange(e, 'city')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "AddrNPho", "city")}
                            helperText={this.validator(TEXT, "AddrNPho", "city")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child State</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["AddrNPho"]["state"]}
                            onChange={e => this.handleChange(e, 'state')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "AddrNPho", "state")}
                            helperText={this.validator(TEXT, "AddrNPho", "state")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Child Zip Code</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["AddrNPho"]["zipcode"]}
                            onChange={e => this.handleChange(e, 'zipcode')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "AddrNPho", "zipcode")}
                            helperText={this.validator(TEXT, "AddrNPho", "zipcode")}
                        />
                    </div>
                </div>

            </div>
        }
        const unitView = () => {
            if (data["country"] === "CN") {
                return <div className="text-wapper">
                    <div className="text-title">Child Unit</div>
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        value={data["unit"]}
                        onChange={e => this.handleChange(e, 'unit')}
                        margin="dense"
                        variant="outlined"
                        error={this.validator(ERR, "unit")}
                        helperText={this.validator(TEXT, "unit")}
                    />
                </div>
            }
        }
        return (
            <Root>
                {content()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            const data = this.props.data;
            if (data && this.props.isAdd) {
                data["DOB"] = timeFormat2(data["DOB"]);
                let panelState = ADD;
                this.setState(() => ({
                    data,
                    panelState
                }))
            }
        }
    }
    initData() {
        const { id, state, isAdd } = this.props;
        let data = {};
        let panelState = "";
        if (isAdd) {
            panelState = ADD;
            data = {
                "N.": "",
                "DOB": timeFormat2(new Date()),
                "SEX": "male",
                "RC": "Son",
                ".CHO.R.C.": "Our;Son",
                "AddrNPho": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
                "id": newId(),
                "type": CHILD
            }
        } else {
            panelState = EDIT;
            const singelData = this.extractData(id);
            data = singelData ? singelData : {};
            data["DOB"] = timeFormat2(data["DOB"]);
        }
        this.setState(() => ({
            data,
            panelState
        }))
    }
    extractData(id) {
        let data = {};
        const singleArr = clone(globalData.singleArr);
        for (const obj of singleArr) {
            if (obj.id === id) {
                data = obj;
            }
        }
        return data;
    }
    setSingleArr() {
        const { data } = this.state;
        const singleArr = globalData.singleArr;
        for (const obj of singleArr) {
            if (obj.id === data.id) {
                Object.assign(obj, data);
            }
        }
    }
    handleAdd() {
        this.setState({
            panelState: EDIT
        })
    }
    handleEdit() {
        this.setState({
            panelState: EDIT
        })
    }
    handleSave(callback = null) {
        const { data } = this.state;
        const { isAdd } = this.props;
        this.setState({
            showMsg: true
        }, () => {
            if (this.doNext()) {
                this.setSingleArr();
                if (callback) callback(true);
                this.props.updateInfoData(data, isAdd);
            } else {
                if (callback) callback(false);
            }
        })
    }
    handleCancel() {
        this.setState({
            panelState: VIEW
        })
    }
    handleChange(e, name) {
        const value = e.target.value;
        const { data } = this.state;
        data[name] = value;
        if (name === "phone" || name === "unit"
            || name === "street" || name === "city"
            || name === "country" || name === "state"
            || name === "zipcode") {
            data["AddrNPho"][name] = value;
        } else if (name === "SEX") {
            if (value === "male") {
                data["RC"] = "Son";
            } else {
                data["RC"] = "Daughter";
            }
        } else if (name === "DOB") {
            // if (getAge(value) < 18) {
            //     globalData.haveNonage = true;
            // } else {
            //     globalData.haveNonage = false;
            // }
        }
        this.setState(() => ({
            data
        }))
    }
    splitName(str) {
        let strArr = str.split(" ");
        if (strArr.length >= 2) {
            return strArr[strArr.length - 1];
        } else {
            return "";
        }
    }
    doNext() {
        const { data } = this.state;
        let canNext = true;
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === "AddrNPho") {
                    canNext = this.verifyAddrValue(data[key]);
                    if (canNext) {
                        continue;
                    }
                } else if (key === ".CHO.Em." || key === "P.W.Pho" || key === "S.W.Pho") {
                    continue;
                }
                if (data[key] === "" || canNext === false) {
                    if (key === "phone") continue;
                    return false;
                }
            }
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    validator(type, name1, name2) {
        const { data, showMsg } = this.state;
        if (showMsg) {
            const value = name2 ? data[name1][name2] : data[name1];
            if (type === ERR) {
                return value ? false : true;
            } else {
                return value ? "" : "This field is required."
            }
        } else {
            const value = type === ERR ? false : "";
            return value;
        }
    }
    isDisabled() {
        return false
        // const { state } = this.props;
        // if (state === ADD) {
        //     return false;
        // } else if (state === VIEW) {
        //     return true;
        // } else if (state === EDIT) {
        //     return false;
        // }
    }
}

export default PanelChild;